import instance from '../index';

export const ReplicateApi = {
  removeBackground({ imageId, image }) {
    const formData = new FormData();

    // Append image with filename and content-type
    formData.append('image', image, {
      filename: 'image.webp',
      contentType: 'image/webp'
    });
    return instance.post(`/images/${imageId}/remove-background`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },

  removeObjects({ imageId, image, mask }) {
    const formData = new FormData();

    // Append image with filename and content-type
    formData.append('image', image, {
      filename: 'image.webp',
      contentType: 'image/webp'
    });

    // Append mask with filename and content-type
    formData.append('mask', mask, {
      filename: 'mask.png',
      contentType: 'image/png'
    });

    return instance.post(`/images/${imageId}/remove-objects`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },

  generateObjects({ imageId, mask, image, prompt }) {
    const formData = new FormData();

    // Append image with filename and content-type
    formData.append('image', image, {
      filename: 'image.jpg',
      contentType: 'image/jpeg'
    });

    // Append mask with filename and content-type
    formData.append('mask', mask, {
      filename: 'mask.png',
      contentType: 'image/png'
    });

    return instance.post(`/images/${imageId}/generate-objects?prompt=${encodeURIComponent(prompt)}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },
  getPredictionStatus(predictionId) {
    return instance.post('/images/prediction-status', { predictionId: String(predictionId) });
  },

  outpaint({ imageId, image, outpaint, prompt }) {
    const formData = new FormData();

    // Append image with filename and content-type
    formData.append('image', image, {
      filename: 'image.webp',
      contentType: 'image/webp'
    });

    return instance.post(`/images/${imageId}/outpaint?outpaint=${encodeURIComponent(outpaint)}&prompt=${encodeURIComponent(prompt)}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },

  generateBackground({ imageId, image }) {
    const formData = new FormData();

    // Append image with filename and content-type
    formData.append('image', image, {
      filename: 'image.webp',
      contentType: 'image/webp'
    });

    return instance.post(`/images/${imageId}/generate-background`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },

  generateVideoWithDirector({ image, content_type, label }) {
    const formData = new FormData();

    // Append image as the required parameter
    // Automatically determine filename and content type from the file if available
    if (image instanceof File) {
      formData.append('image', image, {
        filename: image.name || 'image.jpg',
        contentType: image.type || 'image/jpeg'
      });
    } else if (image) {
      // Fallback if image is not a File object
      formData.append('image', image, {
        filename: 'image.jpg',
        contentType: 'image/jpeg'
      });
    } else {
      console.error('No image provided for video generation');
      return Promise.reject(new Error('Image is required for video generation'));
    }

    // Append content type and label
    formData.append('content_type', content_type);
    formData.append('label', label);

    return instance.post('/videos/generate-with-director', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },

  generateVideoWithKling({ image, label, content_id }) {
    const formData = new FormData();

    // Append image as the required parameter
    // Automatically determine filename and content type from the file if available
    if (image instanceof File) {
      formData.append('image', image, {
        filename: image.name || 'image.jpg',
        contentType: image.type || 'image/jpeg'
      });
    } else if (image) {
      // Fallback if image is not a File object
      formData.append('image', image, {
        filename: 'image.jpg',
        contentType: 'image/jpeg'
      });
    } else {
      console.error('No image provided for video generation');
      return Promise.reject(new Error('Image is required for video generation'));
    }

    // Append label (camera movement)
    formData.append('label', label);

    // Append content_id for tracking purposes
    if (content_id) {
      formData.append('content_id', content_id);
    }

    return instance.post('/videos/generate-with-kling', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },

  generateWithFluxKontext({ imageId, image, prompt, aspectRatio = '1:1', outputFormat = 'webp', safetyTolerance = 2 }) {
    const formData = new FormData();

    // Append image with filename and content-type
    formData.append('input_image', image, {
      filename: 'image.webp',
      contentType: 'image/webp'
    });

    // Append other parameters
    formData.append('prompt', prompt);
    formData.append('aspect_ratio', aspectRatio);
    formData.append('output_format', outputFormat);
    formData.append('safety_tolerance', safetyTolerance.toString());

    return instance.post(`/images/${imageId}/generate-with-flux-kontext`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  }
};

export default ReplicateApi;
